import "../styles/all.css"
import Start from "../component/start/start";
import Cards from "../component/cards/card";
import Three from "../component/threesection/three";
import Barnd from "../component/brand/brand";
import Vison from "../component/vison/vison";
import Client from "../component/client/client";
import Services from "../component/services/services";
import Project from "../component/project/project";
function Home(){
    return(
        <>
         <Start/>
      <Cards/>
      <Three/>
      <Barnd/>
     <Vison/>
     <Client/>
     <Services/>
     <Project/>
        </>
    )
}
export default Home